export default __webpack_public_path__ + "static/media/school.1d3a6516.jpeg";